export const EXTERNAL_PDF = 'external_pdf';
